/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-03-24 19:40:50
 * @LastEditors  : 程哲林
 * @LastEditTime : 2022-06-10 18:12:58
 * @FilePath     : /mall-fe/src/utils/sensors.ts
 * @Description  : 未添加文件描述
 */

import storage from '@woulsl/storage';
import React from 'react';

import { getCurrPlatformText } from './util';

let timer: any = null;

function channelSlice(channel: string | string[] | null) {
  try {
    if (!channel) {
      return {};
    }
    const channelStr = Array.isArray(channel) ? channel[0] : channel;
    const re = /^(?<system>([a-z0-9]*_){3}[a-z0-9]*)(?<custom>(-[a-z0-9]*){1,})$/gim;
    const exec = re.exec(channelStr);
    if (exec && exec.groups) {
      const { system = '', custom = '' } = exec.groups;
      const systemArr = system.split('_');
      const customStr = custom.replace(/^-/, '');
      // console.log(systemArr, customStr);

      return {
        business_ownership: systemArr[0],
        channel_name: systemArr[1],
        service_provider: systemArr[2],
        custom_platform: systemArr[3],
        custom_state: customStr
      };
    }
  } catch (e) {
    console.log(e);
  }

  return {};
}

export const getSensData = () => {
  try {
    return storage.get('mall_sensData') || {};
  } catch (e) {
    console.log(e);
  }
  return {};
};

export const saveSensData = (data: any) => {
  try {
    storage.set('mall_sensData', data, 60000);

    /* if (localStorage && typeof localStorage.setItem === 'function') {
      localStorage.setItem(
        'sensData',
        JSON.stringify({
          ...getSensData(),
          ...data
        })
      );
    } */
  } catch (e) {
    console.log(e);
  }
};

export const handleValues = (values: any) => {
  let params = {
    ...sensors.getPresetProperties(),
    activity_label: '商城',
    ...values
  };
  if (!values.nobaseData) {
    const baseData = getSensData();
    params = { ...baseData, ...params };
  }
  delete params.nobaseData;
  delete params._distinct_id;
  return params;
};

export const sensClickInitiative = async (values: any = {}) => {
  try {
    const p = await getCurrPlatformText();
    sensors.quick('isReady', function () {
      sensors.track('$WebClick', {
        ...handleValues(values),
        custom_platform: p
      });
    });
  } catch (e) {
    console.error(e);
  }
};

export const sensClick = (e: React.UIEvent) => {
  try {
    e.persist();
    const ele = e.currentTarget as HTMLElement;
    const newValues: any = {};
    for (const [key, val] of Object.entries(ele.dataset)) {
      if (key.includes('element')) {
        newValues[`$${key}`] = val;
      } else if (key === 'sku_id' && val) {
        newValues[key] = val.toString().split(',');
      } else {
        newValues[key] = val;
      }
    }
    sensClickInitiative(newValues);
  } catch (error) {
    console.error(error);
  }
};

export const sensAutoTrack = (values: any = {}) => {
  try {
    clearTimeout(timer);
    timer = setTimeout(() => {
      sensors.quick('isReady', function () {
        sensors.quick('autoTrack', handleValues(values));
      });
      timer = null;
    }, 150);
  } catch (e) {
    console.error(e);
  }
};

export const sensElementView = (values: any = {}) => {
  try {
    sensors.track('ElementView', handleValues(values));
  } catch (e) {
    console.error(e);
  }
};

// 浏览页面时
export const sensPageView = async (values: any = {}) => {
  const { channelNo, ...rest } = values;
  try {
    sensors.track('$pageview', {
      ...handleValues(rest),
      ...channelSlice(rest.channel),
      ...(channelNo ? { channel_no: channelNo } : {})
    });
  } catch (e) {
    console.error(e);
  }
};

// 曝光
export const Exposure = async (ele: any, option?: any) => {
  try {
    if (window.sensorsExpoSure && ele) {
      const p = await getCurrPlatformText();
      window.sensorsExpoSure.addExposureView(ele, {
        eventName: 'ElementView',
        config: {
          area_rate: 0.5,
          stay_duration: 2,
          repeated: false
        },
        properties: {
          ...sensors.getPresetProperties(),
          ...getSensData(),
          ...(option ?? {}),
          custom_platform: p
        }
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const exposureDom = (id: string, option?: any) => {
  try {
    const $el = document.getElementById(id);
    if ($el) {
      Exposure($el, option);
    }
  } catch (error) {
    console.log(error);
  }
};
